import React from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';

import { formatNull, formatOverflow } from '../../Utils/GlobalUtils';

import Modal from '../../Components/Modal';
import SearchDebtors from '../../Components/SearchModals/SearchDebtors';

import Loading from '../../Components/Loading';
import LoadingLines from '../../Components/LoadingLines';
import WarningPanel from '../../Components/WarningPanel';

import headerPanel from '../../styles/HeaderPanel.module.css';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

export default function RegisterOfDebtors() {
  const location = useLocation();
  const navigate = useNavigate();

  const [debtors, setDebtors] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [reload, setReload] = React.useState(true);

  const [isSearch, setIsSearch] = React.useState(false);

  const [limitForView, setLimitForView] = React.useState(50);
  const [lastUpdateTime, setLastUpdateTime] = React.useState('');

  const token = localStorage.getItem('token');
  React.useEffect(() => {
    setLoading(true);
    axios.get(`/api/get-all-debtors?limitForView=${limitForView}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setDebtors(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
      setLastUpdateTime(new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }));
    })
  }, [reload]);

  
  return (
    <>
      <Modal isOpen={isSearch} closeModal={() => { window.location.hash = ''; setIsSearch(false) }}>
        <SearchDebtors />
      </Modal>

      <div className={headerPanel.panel}>
        <button className='button' onClick={() => navigate(`/add-new-debtor`, { state: { from: location.pathname + location.search + location.hash }})}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z" /></svg>
            Добавить должника
        </button>
        <div className={headerPanel.searchBtn} onClick={() => setIsSearch(true)}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" /></svg>
            Поиск...
        </div>
      </div>
      
      <div className='pageWrapper'>
        <div className='tableContainer'>
          <div className='tableHeaderWrapper'>
            <div className='tableStatus'>
                <div></div>
                <a className='lastUpdateWrapper'>
                    Последнее обновление таблицы: {lastUpdateTime || '--:--'} 
                    {loading ? 
                        <Loading type='inline' /> 
                    : 
                        <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                    }
                </a>
            </div>
            <div className='tableHeader' style={{gridTemplateColumns: '17fr 7fr 19fr 11fr 11fr 22fr'}}>
                <div>ФИО или наименование</div>
                <div>Категория должника</div>
                <div>Адрес</div>
                <div>ИНН</div>
                <div>ОГРН(ИП)</div>
                <div>Примечание</div>
            </div>
          </div>
          {(debtors.length===0 && loading) ? <LoadingLines />
          : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
          : debtors.map((debtor) => (
              <motion.div 
                className='tableRow' 
                key={debtor.id} 
                style={{gridTemplateColumns: '17fr 7fr 19fr 11fr 11fr 22fr'}}
                onClick={() => { 
                  navigate(`/debtor/${debtor.id}`, { state: { from: location.pathname + location.search + location.hash }})
                }}
                initial={{ scale: '97%', opacity: 0 }}
                animate={{ scale: '100%', opacity: 1 }}
                exit={{ scale: '97%', opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                  <div>{formatNull(debtor.name)}</div>
                  <div>{formatNull(debtor.entity_type)}</div>
                  <div>{formatNull(debtor.postal_address)}</div>
                  <div>{formatNull(debtor.TIN)}</div>
                  <div>{formatNull(debtor.OGRN)}</div>
                  <div>{formatOverflow(formatNull(debtor.description))}</div>
              </motion.div>
          ))}
          {!warning && debtors.length > 0 && (debtors.length < debtors[0].total_count) && (
              <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                  <div></div>
                  <div>
                      <button
                          type='button'
                          className='button'
                          style={{ width: 'fit-content' }}
                          onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                          disabled={loading}
                      >
                          {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                      </button>
                  </div>
                  <div></div>
              </div>
          )}
        </div>
      </div>
    </>
  )
}
